/**
 * Data-access hook for the admin gate. Components/guards call THIS, never
 * useQuery against /api/admin/me directly (andavo-dev convention).
 */
import { useQuery } from '@tanstack/react-query';
import { adminMeQueries } from './admin-me-query';

export function useAdminMe() {
  return useQuery(adminMeQueries.me());
}
